// @ts-ignore
import settingsIcon from "../assets/icon-settings.svg"
import { goToCompanySettings } from "../util/routes"

export const companyNavItems = (t: any, userIsCrew: boolean): any[] => {
  return userIsCrew
    ? []
    : [
      {
        icon: settingsIcon,
        route: goToCompanySettings,
        text: t("Settings"),
      }
    ]
}
